// ============================================================
// PLUMME 2.0 — Lat lasting av tunge CDN-biblioteker
// ============================================================
// xlsx.full.min.js er 882 KB og brukes bare naar noen faktisk importerer eller
// eksporterer et regneark. Lastet i <head> maatte hver oppstart vente paa den —
// merkbart i Safari, der parsing av store skript er dyrere. Samme moenster som
// `loadPdfJsLib` i src/pdfviewer.jsx: last ved forste bruk, del paa ett loefte.
//
// Kallstedene beholder sin `if (!window.XLSX) throw`-sjekk, saa en CDN som er nede
// fortsatt gir feilmeldingen sin i stedet for en uforstaaelig TypeError.

// SheetJS publiserer ikke lenger til npm; 0.18.5 der har prototype pollution ved lesing
// av en manipulert fil (CVE-2023-30533) og ReDoS (CVE-2024-22363). Fiksede versjoner
// finnes bare pa SheetJS sin egen CDN.
const XLSX_SCRIPT = 'https://cdn.sheetjs.com/xlsx-0.20.3/package/dist/xlsx.full.min.js';
// SRI: en kompromittert CDN-fil skal ikke kjore med brukerens sesjon. Ny versjon = ny hash.
const XLSX_INTEGRITY = 'sha384-EnyY0/GSHQGSxSgMwaIPzSESbqoOLSexfnSMN2AP+39Ckmn92stwABZynq1JyzdT';

function loadXLSX() {
  if (window.XLSX) return Promise.resolve(window.XLSX);
  if (window.__plummeXlsxLoading) return window.__plummeXlsxLoading;
  window.__plummeXlsxLoading = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = XLSX_SCRIPT;
    script.async = true;
    script.integrity = XLSX_INTEGRITY;
    script.crossOrigin = 'anonymous';
    script.onload = () => resolve(window.XLSX);
    script.onerror = () => {
      // Nullstill saa neste forsoek kan proeve paa nytt i stedet for aa arve feilen.
      window.__plummeXlsxLoading = null;
      reject(new Error('xlsx missing'));
    };
    document.head.appendChild(script);
  });
  return window.__plummeXlsxLoading;
}

window.loadXLSX = loadXLSX;
